<template>
  <div class="pt-8 flex-1 flex flex-col bg-white">
    <div class="flex items-center px-6">
      <router-link :to="{ name: 'account' }">
        <svg
          class="w-8 h-8 text-gray-600 -ml-3"
          fill="currentColor"
          viewBox="0 0 20 20"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
            clip-rule="evenodd"
          ></path>
        </svg>
      </router-link>
      <div>
        <h1 class="text-2xl font-medium text-gray-800 ml-6">
          {{ $t("global.Phone") }}
        </h1>
      </div>
    </div>

    <div class="w-full mt-6 px-6">
      <form action="#" method="POST" @submit.prevent="updatePhone">
        <div class="mt-1 relative rounded-md shadow-sm">
          <div
            class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none"
          >
            <!-- Heroicon name: solid/phone -->
            <svg
              class="mt-0.5 h-5 w-5 text-gray-500"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
              ></path>
            </svg>
          </div>
          <input
            v-model="phone"
            id="phone"
            :placeholder="$t('global.Phone')"
            type="phone"
            required
            class="pl-12 bg-gray-primary-100 appearance-none block w-full py-5 px-4 rounded-lg text-gray-500 placeholder-gray-400 focus:outline-none focus:border-blue-400 transition duration-150 ease-in-out font-medium sm:leading-5"
          />
        </div>
        <div class="mt-12 text-center">
          <button
            type="submit"
            class="w-full text-white bg-blue-primary-500 flex items-center justify-center rounded-lg py-4 border border-transparent"
          >
            {{ $t("global.Confirm") }}
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

import auth from "@/api/auth";

export default {
  data() {
    return {
      phone: ""
    };
  },

  computed: {
    ...mapState("auth", ["user"])
  },

  mounted() {
    this.phone = this.user.phone;
  },

  methods: {
    updatePhone() {
      auth
        .update({
          _method: "PUT",
          phone: this.phone
        })
        .then(() => {
          this.$router.push({
            name: "account"
          });
        })
        .catch(err => {
          console.log(err.response);
        });
    }
  }
};
</script>
